import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { I18n } from 'react-redux-i18n'
import { Box, Link } from '@mui/material'

import api from 'api'
import { LoginDetails, useAuth } from 'auth'
import { Role } from 'types'
import LoginForm from './LoginForm'
import { FinePrint, LoginFormWrapper, LoginPageWrapper } from './LoginForm/styled'

const LoginPage = () => {
  const { isAuthenticated } = useAuth()
  const location = useLocation()

  if (isAuthenticated) {
    const state = location.state as any // https://github.com/reach/router/issues/414
    return <Navigate to={state?.from ?? '/'} />
  }

  const onRequest = async ({ email, password }: LoginDetails) => {
    if (!email || !password) {
      return { code: 'Input' as const }
    }

    try {
      const { token } = await api.Auth.login({ email, password })
      const { role } = await api.Auth.getUser(token)

      if (role?.toLowerCase() !== Role.Admin.toLowerCase())
        return { code: 'Custom' as const, message: I18n.t('General.Forbidden') }

      return token
    } catch (e: any) {
      switch (e.status) {
        case 401:
          return {
            code: 'Unauthorized' as const,
          }
        case 403:
          return {
            code: 'Custom' as const,
            message: 'Forbidden',
          }
        default:
          return {
            code: 'Unknown' as const,
          }
      }
    }
  }

  return (
    <LoginPageWrapper>
      <Box py={8}>
        <LoginFormWrapper>
          <LoginForm title="Logtrade Move" onRequest={onRequest} />
        </LoginFormWrapper>
        <Box mt={2}>
          <FinePrint>
            Lost your password?{' '}
            <Link
              component="button"
              onClick={() => {
                window.location.href = 'https://www.logtrade.se/en/contact/'
              }}
            >
              Contact us
            </Link>
          </FinePrint>
        </Box>
      </Box>
    </LoginPageWrapper>
  )
}

export default LoginPage
